import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class File7 extends Vue
{
  private _configuratorService: ConfiguratorService = undefined;

  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedArmletType: string = ReflexdArmletType.Constant;
  seletedFoot: string = FileFoot.Krom;

  defHideObjects = [
    '_yy',
    'kolcak_plastik',
  ];

  defShowObjects = [
    'file_7_sirt_braket_siyah_yyy',
    'xxx_file_alt_yyy',
    'file_7_sirt_yy',
    'xxx_file_kolcak_sag_yyy',
    'xxx_file_kolcak_sol_yyy',
    'file_ayak_plastik_yyy',
    'xxx_file_kolcak_dugme_yyy',
    'xxx_file_donati_yyy',
    'genisliksiz',
    'kizaksiz',
    'donati',
    'xxx_file_kolcak_dugme_sol_yyy',
    'xxx_file_kolcak_dugme_sag_yyy',
    'file_7_arkalik_karkasi_boyali_yyy',
    'file_7_arkalik_karkasi_boyali_yyy',
  ];

  availableAnimations: AnimationDefinition[] = [];

  async created()
  {
    this.product = Store.getProductById('file7');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.availableAnimations = this.product.animations as any;
    this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });

    if (Store.state.selection)
    {
      Store.state.selection.parts.forEach((element) =>
      {
        this.colorChanged(element.color, element.palette, element.id);
      });

      if (Store.state.selection.footAndHand === FileFoot.Metal)
      {
        await this.changeFoot(FileFoot.Metal);
      }
      if (Store.state.selection.footAndHand === FileFoot.Krom)
      {
        await this.changeFoot(FileFoot.Krom);
      }
      if (Store.state.selection.footAndHand === FileFoot.Plastik)
      {
        await this.changeFoot(FileFoot.Plastik);
        if (Store.state.selection.armletType === ReflexdArmletType.Constant)
        {
          await this.changeArmletType(ReflexdArmletType.Constant);
        }
      }
    } else
    {
      await this.applyDefaultSelection();
    }
  }

  availableAnimationsChanged()
  {
    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  mounted()
  {
    // this.configuratorService = Store.state.configuratorService;
  }

  async applyDefaultSelection()
  {
    const selection = new File7Selection();
    selection.parts = [];
    selection.footAndHand = FileFoot.Krom;
    selection.armletType = ReflexdArmletType.Constant;
    this.product.defaults.parts.forEach((element) =>
    {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    await this.changeFoot(FileFoot.Krom);
  }


  async changeFoot(foot: FileFoot)
  {
    if (foot === FileFoot.Metal)
    {
      await this._configuratorService.hideObjects({ objects: ['file_ayak_plastik_yyy', 'file_ayak_krom_yyy', 'file_kolcak_demir_genisliksiz_krom_yyy', 'file_kolcak_demir_genisliksiz_plastik_yyy', 'file_7_sirt_braket_siyah_yyy', 'kolcak_plastik', 'file_lama_kolcak_krom_yyy', 'file_7_arkalik_karkasi_boyali_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_ayak_aluminyum_yyy', 'file_kolcak_demir_genisliksiz_aluminyum_yyy', 'file_7_sirt_braket_aluminyum_yyy', 'xxx_file_kolcak', 'file_7_arkalik_karkasi_metal_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = FileFoot.Metal;
      this.seletedFoot = FileFoot.Metal;
      this.armletAnimations(true);
      Store.state.selection.armletType = ReflexdArmletType.Adjustable;
      this.seletedArmletType = ReflexdArmletType.Adjustable;
    }
    if (foot === FileFoot.Plastik)
    {
      await this._configuratorService.hideObjects({ objects: ['file_ayak_aluminyum_yyy', 'file_ayak_krom_yyy', 'file_kolcak_demir_genisliksiz_krom_yyy', 'file_kolcak_demir_genisliksiz_aluminyum_yyy', 'file_7_sirt_braket_aluminyum_yyy', 'kolcak_plastik', 'file_lama_kolcak_krom_yyy', 'file_7_arkalik_karkasi_metal_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_ayak_plastik_yyy', 'file_kolcak_demir_genisliksiz_plastik_yyy', 'file_7_sirt_braket_siyah_yyy', 'xxx_file_kolcak', 'file_7_arkalik_karkasi_boyali_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = FileFoot.Plastik;
      this.seletedFoot = FileFoot.Plastik;
      this.seletedArmletType = ReflexdArmletType.Adjustable;
      this.armletAnimations(true);
      if (Store.state.selection.armletType === ReflexdArmletType.Constant)
      {
        await this.changeArmletType(ReflexdArmletType.Constant);
      }
    }
    if (foot === FileFoot.Krom)
    {
      await this._configuratorService.hideObjects({ objects: ['file_ayak_aluminyum_yyy', 'file_ayak_plastik_yyy', 'file_kolcak_demir_genisliksiz_aluminyum_yyy', 'file_kolcak_demir_genisliksiz_plastik_yyy', 'file_7_sirt_braket_siyah_yyy', 'kolcak_plastik', 'file_kolcak_demir_genisliksiz_krom_yyy', 'xxx_file_kolcak', 'file_7_arkalik_karkasi_boyali_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_ayak_krom_yyy', 'file_lama_kolcak_krom_yyy', 'file_7_sirt_braket_aluminyum_yyy', 'file_7_arkalik_karkasi_metal_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = FileFoot.Krom;
      this.seletedFoot = FileFoot.Krom;
      this.armletAnimations(false);
      Store.state.selection.armletType = ReflexdArmletType.Constant;
      this.seletedArmletType = ReflexdArmletType.Constant;
    }
  }

  async changeArmletType(arm: ReflexdArmletType)
  {
    if (arm === ReflexdArmletType.Constant)
    {
      await this._configuratorService.showObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['file_kolcak_demir_genisliksiz_plastik_yyy', 'file_ayak_aluminyum_yyy', 'file_ayak_krom_yyy', 'file_kolcak_demir_genisliksiz_krom_yyy', 'file_kolcak_demir_genisliksiz_aluminyum_yyy', 'file_7_sirt_braket_aluminyum_yyy', 'xxx_file_kolcak'], operator: FilterOperators.Contains });
      this.armletAnimations(false);
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
    }
    if (arm === ReflexdArmletType.Adjustable)
    {
      await this._configuratorService.showObjects({ objects: ['file_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_file_kolcak'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
      this.armletAnimations(true);
    }
  }
  armletAnimations(isKizakli: boolean)
  {
    let animations = [];

    if (!isKizakli)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a1'))
        {
          animations.push(element);
        }
      });
    } else
    {
      animations = this.product.animations as any[];
    }

    this.availableAnimations = animations;
    this.availableAnimationsChanged();
  }

  async colorChanged(color: any, palette: any, part: any)
  {
    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });

    if (part === 'file_7_back')
    {

      const op: string = getColor.texture.split('.jpg')[0] + '_opacity.jpg';
      console.log(op);
      this._configuratorService.changeOpacity({
        materials: getPart.materials,
        texture: op,

      });
      await this._configuratorService.changeBumpMap({
        materials: getPart.materials,
        texture: op,
      });
    }
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class File7Selection
{
  parts: PartSelection[];
  footAndHand: FileFoot;
  armletType: ReflexdArmletType;
}
export class PartSelection
{
  id: string;
  palette: string;
  color: string;
  name: string;
}
enum FileFoot
{
  Metal = 'metal',
  Plastik = 'plastik',
  Krom = 'krom',
}

enum ReflexdArmletType
{
  Constant = 'constant',
  Adjustable = 'adjustable',
}



// WEBPACK FOOTER //
// ./src/components/families/file/File7.ts